import axios from "axios";
import ProductRepository from "../../../repositories/ProductRepository";
import Endpoint from "../../../services/endpoint";
import GeneralUtility from "../../../utils/general-utility";
import { setBulkAddDialog, setId, setPage, setTypeForm } from "./Reducer";

const getPage = async (dispatch, { page }) => {
    dispatch(setPage(page));
};

const onEdit = async (dispatch, id, typeForm) => {
    dispatch(setId(id));
    dispatch(setTypeForm(typeForm));
    getPage(dispatch, { page: "edit" });
};

const downloadTemplate = async (dispatch) => {
    try {
        const BASE_API = process.env.REACT_APP_BASE_API;
        const url = BASE_API + Endpoint.download_template_bulk_add;
        const token = await GeneralUtility.getToken();
        const response = await axios.post(url, null, {
            responseType: 'blob',
            headers: {
                'Authorization': `Bearer ${token}`,
                'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            }
        });
        if (!response.data || response.data.size === 0) {
            console.error('Empty response received from server');
        }
        await GeneralUtility.downloadExcelFile(response.data, "template-bulk-add-product.xlsx");
        dispatch(setBulkAddDialog(false));
        dispatch(setBulkAddDialog(false));
    } catch (error) {
        console.error('Error downloading template:', error);
        dispatch(setBulkAddDialog(false));
    }

};

const Action = {
    getPage,
    onEdit,
    downloadTemplate
};

export default Action;
